import React from 'react';

/**
 * This is just an Example component.
 * Copyright (c) 2019 Decisions ALl Rights Reserved
 */
export function HtmlVideo({ child }) {
  return <video src={child.Value.OutputValue} />;
}
